import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { calendarAsMemberQueryKeys } from "../calendarAsMember";
import { eventOccurrenceAsMemberQueryKeys } from "./eventOccurrenceAsMemberQueryKeys";

export const useMutationAddMemberToOccurrenceAsMember = ({
  api,
}: {
  api: ApiType;
}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ occurrenceId }: { occurrenceId: number }) =>
      (await api.customerOccurrenceApi.addAttendeeToRsvp(occurrenceId)).data,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: eventOccurrenceAsMemberQueryKeys.all(),
      });
      await queryClient.invalidateQueries({
        queryKey: calendarAsMemberQueryKeys.eventOccurrences(),
      });
      await queryClient.invalidateQueries({
        queryKey: calendarAsMemberQueryKeys.userMemberBookingAgenda(),
      });
    },
  });
};
